var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 5,
    viewBox: "0 0 7 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.1535 4.3515L0.143719 1.3415C-0.0479062 1.15009 -0.0479062 0.839684 0.143719 0.648277C0.335344 0.456871 0.645531 0.456871 0.836938 0.648277L3.50022 3.31156L6.16328 0.648277C6.35469 0.456871 6.66509 0.456871 6.8565 0.648277C7.04791 0.839684 7.04791 1.15009 6.8565 1.3415L3.84672 4.3515C3.75091 4.44709 3.62556 4.495 3.50022 4.495C3.37487 4.495 3.24931 4.44709 3.15372 4.3515L3.1535 4.3515Z",
    fill: "#281B65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarArrow);
export default __webpack_public_path__ + "static/media/sidebar-arrow.e828306014faaf927b21e996ce009501.svg";
export { ForwardRef as ReactComponent };